module.exports = __webpack_public_path__ + "img/vorauskasse-data.c4affd26.svg";